<template>
	<div>
		<v-row class="mt-4 flex-nowrap" no-gutters>
			<v-text-field
				:label="column.required_flag ? `${column.name}（必須）` : column.name"
				class="clickable"
				v-model="displayValue"
				readonly
				dense
				outlined
				@mousedown.stop="openDialog()"
			/>
			<template v-if="displayValue">
				<v-menu v-if="(itemId && !isDraft) || isDraft">
					<template v-slot:activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" class="ml-2" icon
							><v-icon> mdi-close-circle-outline</v-icon></v-btn
						>
					</template>
					<v-card class="pa-2 pt-4" max-width="300">
						<p v-if="itemId && !isDraft" class="text-body-2">
							既に作成されたデータは削除されません。<br />
							削除するには、台帳ページやマスターデータから削除する必要があります。
						</p>
						<p v-else-if="isDraft" class="text-body-2">
							下書きデータが削除されますが、よろしいですか。
						</p>
						<v-card-actions class="ma-0 pa-0">
							<v-row no-gutters class="pa-2" justify="space-around">
								<v-btn @click="cancelTarget" color="secondary">
									<v-icon class="mr-1">mdi-delete</v-icon>
									<template v-if="itemId && !isDraft"> フォームを空にする </template>
									<template v-else-if="isDraft"> 下書きデータを削除する </template>
								</v-btn>
								<!-- <v-btn @click="warningMenu = false" color="grey" text> キャンセル </v-btn> -->
							</v-row>
						</v-card-actions>
					</v-card>
				</v-menu>
				<v-btn v-else @click="cancelTarget" class="ml-2" icon
					><v-icon> mdi-close-circle-outline</v-icon></v-btn
				>
			</template>
		</v-row>

		<v-dialog
			v-model="dialog"
			max-width="800px"
			:fullscreen="$vuetify.breakpoint.xs ? true : false"
			:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
		>
			<v-card ref="synchronizationDialog">
				<v-app-bar dense dark flat color="primary">
					<v-app-bar-title class="color-white">{{ dialogTitle }}</v-app-bar-title>
					<v-spacer />
					<v-btn icon dark @click="dialog = false" color="white">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-app-bar>
				<!-- v-if="
						column.data_synchronization.create_if_blank &&
						!column.data_synchronization.always_create
					" -->
				<v-row no-gutters justify="end" class="pa-2">
					<template v-if="!showNewForm">
						<v-btn @click="showNewForm = !showNewForm" color="secondary">
							<v-icon class="mr-1">mdi-plus</v-icon>
							新規データ作成
						</v-btn>
					</template>
					<template v-else>
						<v-menu v-model="warningMenu">
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" v-on="on" color="secondary">
									<v-icon class="mr-1">mdi-back</v-icon>
									選択画面を表示する
								</v-btn>
							</template>
							<v-card class="pa-2 pt-4" max-width="300">
								<p v-if="isDraft" class="text-body-2">
									選択画面からデータを選択すると、下書きデータは削除されますが、よろしいですか。
								</p>
								<p v-else class="text-body-2">
									選択画面に戻ると、現在入力されている項目は保存されません。
								</p>
								<!-- <p v-else class="text-body-2">
									選択画面からデータを選択しても、既存のデータは削除されません。<br />
									削除するには、台帳ページやマスターデータから削除する必要があります。
								</p> -->
								<v-card-actions class="ma-0 pa-0">
									<v-row no-gutters class="pa-2" justify="space-around">
										<v-btn class="mt-4" @click="openForm()" color="secondary">
											<v-icon class="mr-1">mdi-back</v-icon>
											選択画面を表示する
										</v-btn>
										<v-btn class="mt-4" @click="warningMenu = false" color="grey" text>
											キャンセル
										</v-btn>
									</v-row>
								</v-card-actions>
							</v-card>
						</v-menu>
					</template>
				</v-row>

				<v-card-text class="pa-2 table-container" v-if="!showNewForm">
					<v-data-table
						locale="ja-JP"
						:headers="tableHeaders"
						:items="items"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr @click="openMenu($event, item.id)" class="clickable">
								<td v-for="(column, i) in columns" :key="i">
									{{ tdValue(column, item) }}
								</td>
							</tr></template
						>
					</v-data-table>
					<v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
						<v-list>
							<v-list-item @click="setTarget">
								<v-list-item-title>データを選択する</v-list-item-title>
							</v-list-item>
							<v-list-item @click="setTargetAndEdit">
								<v-list-item-title>データを選択して編集する</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>

					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
					<v-card-actions>
						<v-row no-gutters justify="end" class="pb-2">
							<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
						</v-row>
					</v-card-actions>
				</v-card-text>
				<template v-else>
					<v-form ref="form" v-model="valid" class="pa-2">
						<RubberProcessForm
							v-if="column.data_synchronization.reflect_model == 'RubberProcess'"
							:id="itemId"
							:data_synchronization_id="column.data_synchronization.id"
							:is_draft="isDraft"
							:draft_data="isDraft && !common.isEmptyObject(value) ? value : null"
							:showOnlySelectedColumns="!!column.data_synchronization.column_name.length"
							:selectedColumns="
								column.data_synchronization.column_name.length
									? column.data_synchronization.column_name
									: []
							"
							:rubber_process.sync="newItem"
							:errors="errors"
							requireFetch
						/>
						<v-divider class="my-4 px-4" />
						<v-row no-gutters class="py-2">
							<v-col sm="3" cols="0" />
							<v-col sm="6" cols="12">
								<!-- <template v-if="itemId && !isDraft"> -->
								<template v-if="itemId">
									<v-row no-gutters justify="center">
										<v-btn
											:class="valid ? '' : 'v-btn--disabled'"
											color="secondary"
											@click="valid ? setUpdateItem() : validate()"
										>
											<v-icon class="mr-1">mdi-pencil</v-icon>
											データ編集
										</v-btn>
									</v-row>
								</template>
								<template v-else>
									<v-row no-gutters justify="center">
										<v-btn
											:class="valid ? '' : 'v-btn--disabled'"
											color="secondary"
											@click="valid ? setNewItem() : validate()"
										>
											<v-icon class="mr-1">mdi-plus</v-icon>
											データ作成
										</v-btn>
									</v-row>
								</template>
							</v-col>
							<v-col sm="3" cols="0" v-if="!$vuetify.breakpoint.xs">
								<v-row no-gutters justify="end">
									<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
								</v-row>
							</v-col>
						</v-row>
					</v-form>
				</template>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import moment from "moment/min/moment.min.js"
import axios from "axios"
import rules from "../../helper/rules"
import common from "../../helper/common"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import PaginationModule from "./PaginationModule.vue"

export default {
	components: {
		PaginationModule,
		RubberProcessForm: () => import("../rubber_process/components/RubberProcessForm.vue"),
	},
	props: {
		column: {
			type: Object,
			required: true,
		},
		value: {
			type: null,
			required: true,
		},
		display_value: {
			type: null,
			required: true,
		},
		id: {
			type: null,
			required: false,
		},
		is_draft: {
			type: Boolean,
			required: false,
			default: false,
		},
		synchronized_datum: {
			type: Object,
			required: false,
			default: null,
		},
		reference_id: {
			type: null,
			required: false,
			default: null,
		},
	},
	data() {
		return {
			dialog: false,
			valid: false,
			errors: [],
			items: [],
			showNewForm: false,
			newItem: {},
			columns: [],
			tableHeaders: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			itemId: null,
			isDraft: false,
			warningMenu: false,
			selectedId: null,
			showMenu: false,
			x: null,
			y: null,
			rules,
			common,
		}
	},
	mounted() {
		this.isDraft = this.is_draft

		if (this.column.data_synchronization.always_create) {
			this.showNewForm = true
		}
		if (this.id != null) {
			this.showNewForm = true
			this.itemId = this.id
		}
		this.columns = this.column.data_synchronization.index_columns
		this.tableHeaders = this.column.data_synchronization.index_columns?.map((column) => {
			let width = column.width ? column.width : 200
			return { text: column.name, value: column.id, width }
		})
	},
	methods: {
		getAssociationData(i) {
			const headers = authenticate.setHeader()
			let url = `/erp/v1/data_synchronizations/${this.column.data_synchronization.id}`
			axios
				.get(url, {
					headers,
					params: {
						page: i,
					},
				})
				.then((res) => {
					this.items = res.data.items
					this.pagination = res.data.pagination
					this.dialog = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(i) {
			const element = this.$refs.synchronizationDialog.$el.parentElement
			element.scrollTo({
				top: 0,
				behavior: "smooth",
			})
			this.getAssociationData(i)
		},
		openMenu(e, id) {
			this.selectedId = id
			this.showMenu = false
			this.x = e.clientX
			this.y = e.clientY
			this.$nextTick(() => {
				this.showMenu = true
			})
		},

		tdValue(column, item) {
			const value_array = column.id.split(".")
			let value = item
			value_array.some((key) => {
				value = value[key]
				if (value == null || value == undefined) {
					return true
				}
			})
			switch (column.data_type) {
				case "date":
					return moment(value).format("YYYY/MM/DD")
				case "datetime":
					return moment(value).format("YYYY/MM/DD HH:mm")
				case "time":
					return moment(value).format("HH:mm")
				default:
					return value
			}
		},
		setNewItem() {
			this.errors = []
			const headers = authenticate.setHeader()
			let url = `/erp/v1/data_synchronizations/${this.column.data_synchronization.id}/synchronized_data`
			axios
				.post(url, { new_item: this.newItem }, { headers })
				.then((res) => {
					const mainColumn = this.columns.find((c) => c.main_column)
					this.displayValue = this.tdValue(mainColumn, this.newItem)
					this.metaValue = this.newItem
					this.dialog = false
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
					const element = this.$refs.synchronizationDialog.$el.parentElement
					element.scrollTo({
						top: 0,
						behavior: "smooth",
					})
				})
		},
		setUpdateItem() {
			this.errors = []
			const headers = authenticate.setHeader()
			const params = { new_item: this.newItem }
			const url = `/erp/v1/data_synchronizations/${this.column.data_synchronization.id}/synchronized_data/${this.itemId}`
			axios
				.put(url, params, { headers })
				.then((res) => {
					const mainColumn = this.columns.find((c) => c.main_column)
					this.displayValue = this.tdValue(mainColumn, this.newItem)
					if (this.itemId) this.newItem.id = this.itemId
					this.metaValue = this.newItem
					this.dialog = false
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
					const element = this.$refs.synchronizationDialog.$el.parentElement
					element.scrollTo({
						top: 0,
						behavior: "smooth",
					})
				})
		},
		setTarget() {
			const item = this.items.find((c) => c.id == this.selectedId)
			const mainColumn = this.columns.find((c) => c.main_column)
			this.displayValue = this.tdValue(mainColumn, item)
			this.metaValue = { id: item.id }
			this.dialog = false
			this.showMenu = false
			this.selectedId = null
		},
		setTargetAndEdit() {
			const item = this.items.find((c) => c.id == this.selectedId)
			this.itemId = item.id
			this.showNewForm = true
			this.showMenu = false
			this.selectedId = null
		},
		cancelTarget() {
			this.displayValue = null
			this.metaValue = {}
			this.showNewForm = false
			this.itemId = null
			this.isDraft = false
			this.$emit("cancel-target")
		},
		openForm() {
			this.getAssociationData(1)
			this.displayValue = null
			this.metaValue = {}
			this.showNewForm = false
			this.warningMenu = false
			this.itemId = null
			this.isDraft = false
			this.$emit("cancel-target")
		},
		openDialog() {
			console.log(this.reference_id)
			if (this.reference_id) {
				this.getCommonTarget()
			} else {
				this.column.data_synchronization.always_create
					? (this.dialog = true)
					: getAssociationData(this.pagination.current)
			}
		},
		getCommonTarget() {
			const headers = authenticate.setHeader()
			let url = `/erp/v1/data_synchronizations/${this.column.data_synchronization.id}/common_targets`
			axios
				.get(url, {
					headers,
					params: {
						reference_id: this.reference_id,
					},
				})
				.then((res) => {
					console.log(res.data)
					this.itemId = res.data.item_id
					this.showNewForm = true
					this.dialog = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		validate() {
			console.log(this.$refs)
			this.$refs.form.validate()
		},
	},
	computed: {
		dialogTitle() {
			if (this.showNewForm) {
				if (this.itemId) {
					return "データ編集"
				} else {
					return "新規データ作成"
				}
			} else {
				return "データ選択"
			}
		},
		metaValue: {
			get() {
				return this.value
			},
			set(newVal) {
				return this.$emit("update:value", newVal)
			},
		},
		displayValue: {
			get() {
				return this.display_value
			},
			set(newVal) {
				return this.$emit("update:display_value", newVal)
			},
		},
	},
	watch: {
		id(val) {
			this.itemId = val
		},
		is_draft(val) {
			this.isDraft = val
		},
		deep: true,
	},
}
</script>

<style lang="scss" scoped>
.v-btn--disabled {
	pointer-events: unset;
	cursor: default;
}
</style>